export const REDIRECT_PATHS = ['/signup', '/forgot', '/welcome', '/resetPassword', '/shopify/retailers/auth'];

export const SIGNIN_PATH = '/signin';
export const SUPER_ADMIN_HOME_PATH = '/suppliers/1/retailers';
export const NEW_RETAILER_PATH = '/newretailer';
export const SHOPIFY_AUTH = '/shopify/retailers/auth';
